import { Download, Search } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';

const csvEscape = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

const exportCsv = (leads) => {
  const header = ['Date', 'Type', 'Name', 'Email', 'Phone', 'Insurance Type / Subject', 'Message'];
  const rows = leads.map((l) => [
    new Date(l.created_at).toLocaleString(), l.type, l.name, l.email, l.phone, l.topic, l.message,
  ]);
  const csv = [header, ...rows].map((r) => r.map(csvEscape).join(',')).join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `leads-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const LeadFilters = ({ filters, onChange, leads }) => {
  const set = (patch) => onChange({ ...filters, ...patch });
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col lg:flex-row lg:items-center gap-4">
      <Tabs value={filters.type} onValueChange={(type) => set({ type })}>
        <TabsList data-testid="lead-type-tabs">
          <TabsTrigger value="all" data-testid="tab-all">All</TabsTrigger>
          <TabsTrigger value="quote" data-testid="tab-quotes">Quotes</TabsTrigger>
          <TabsTrigger value="contact" data-testid="tab-contacts">Contacts</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="relative flex-1">
        <Search className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          data-testid="lead-search-input"
          placeholder="Search name, email, phone, message…"
          value={filters.search}
          onChange={(e) => set({ search: e.target.value })}
          className="pl-9"
        />
      </div>
      <div className="flex items-center gap-2">
        <Input type="date" value={filters.from} onChange={(e) => set({ from: e.target.value })} className="w-40" data-testid="lead-date-from" aria-label="From date" />
        <span className="text-gray-400 text-sm">to</span>
        <Input type="date" value={filters.to} onChange={(e) => set({ to: e.target.value })} className="w-40" data-testid="lead-date-to" aria-label="To date" />
      </div>
      <Button onClick={() => exportCsv(leads)} disabled={!leads.length} className="bg-[#D94B5A] hover:bg-red-800 text-white" data-testid="export-csv-button">
        <Download className="h-4 w-4 mr-2" /> Export CSV
      </Button>
    </div>
  );
};
